<div class="col-sm-6">
    <label>Countries <i class="fa fa-asterisk text-danger"></i></label>
    <div class="help-text">You must target at least one country</div>
    <div class="selections"></div>
</div>
<div class="col-sm-6">
    <div class="countries" style="width: 300px; display: block;"></div>
    <div class="help-block"></div>
</div>
